/** Tally requires base `tally` plus a tab-specific permission. */

export function canViewTallyAssets(hasPermission: (key: string) => boolean): boolean {
  return hasPermission('tally') && hasPermission('tallyAssets')
}

export function canViewTallyInventory(hasPermission: (key: string) => boolean): boolean {
  return hasPermission('tally') && hasPermission('tallyInventory')
}

export function canViewTallyFleet(hasPermission: (key: string) => boolean): boolean {
  return hasPermission('tally') && hasPermission('tallyFleet')
}

/** Create / edit / delete / sync on Assets, Inventory & Fleet tabs. */
export function canManageTally(hasPermission: (key: string) => boolean): boolean {
  return hasPermission('tally') && hasPermission('tallyManager')
}

/** App is visible when `tally` is granted and at least one tab permission is. */
export function canAccessTallyApp(hasPermission: (key: string) => boolean): boolean {
  return (
    hasPermission('tally') &&
    (hasPermission('tallyAssets') || hasPermission('tallyInventory') || hasPermission('tallyFleet'))
  )
}
